import { Pipe, PipeTransform } from '@angular/core';

/**
 * Inserts a <br> after the first space found past a given character position.
 * Usage: {{ text | lineBreakAt:12 }}
 */
@Pipe({ name: 'lineBreakAt' })
export class LineBreakAtPipe implements PipeTransform {
  transform(value: string, pos: number = 12): string {
    if (!value || value.length <= pos) return value;
    const breakPoint = value.indexOf(' ', pos);
    if (breakPoint === -1) return value;
    return value.slice(0, breakPoint) + '<br>' + value.slice(breakPoint + 1);
  }
}
